import api from '@/utils/api';
import { OAuthConsentDetails, OAuthDecisionRequest, OAuthGrant } from '@/lib/types';

// Consent screen data for a pending authorization request (404 when expired).
export async function getOAuthAuthorizationRequest(
  requestId: string,
): Promise<OAuthConsentDetails> {
  const res = await api.get(`oauth/authorize/${encodeURIComponent(requestId)}`);
  return res.data.resource as OAuthConsentDetails;
}

// Records approve/deny and returns the URL to send the browser to (the app's
// redirect_uri, carrying the authorization code or an access_denied error).
export async function decideOAuthAuthorization(
  requestId: string,
  body: OAuthDecisionRequest,
): Promise<{ redirect_to: string }> {
  const res = await api.post(`oauth/authorize/${encodeURIComponent(requestId)}/decision`, body);
  return res.data.resource as { redirect_to: string };
}

export async function listOAuthGrants(): Promise<OAuthGrant[]> {
  const res = await api.get('oauth/grants');
  return (res.data.resource as OAuthGrant[]) ?? [];
}

export async function revokeOAuthGrant(id: number): Promise<void> {
  await api.delete(`oauth/grants/${id}`);
}

// The URL a user pastes into Claude / ChatGPT: the API origin + /mcp.
export function mcpEndpointURL(): string {
  const base = (import.meta.env.VITE_API_URL as string | undefined) ?? '';
  return base.replace(/\/api\/v1\/?$/, '').replace(/\/$/, '') + '/mcp';
}

export const scopeLabels: Record<string, string> = {
  'read:workspace': 'Workspaces',
  'read:content': 'Content',
  'read:calendar': 'Calendar',
  'read:planner': 'Practice plans',
  'read:courses': 'Courses',
  'read:library': 'Library',
  'write:planner': 'Edit practice plans',
  'write:calendar': 'Edit calendar',
  'write:content': 'Edit content',
  'write:courses': 'Edit course covers',
};
